import { isLegacyBrowser } from 'lib/browser';

export const isSafariOrIE = (browser) => {
  const isSafari = browser.name === 'Safari';
  const isInternetExplorer = isLegacyBrowser(browser.name);

  const isSafariOrIE = isInternetExplorer || isSafari;

  return isSafariOrIE;
};
